<template>
  <div class="card purple">
    <div class="content">
      <div class="header">
        {{ $t('MQ') }}
        <i class="right floated sitemap icon"></i>
      </div>
      <div class="meta">
        {{
          $t('MQ_META', {
            serviceName: (service && service.name) || '',
            messagePattern: trigger.configuration.messagePattern
          })
        }}
      </div>
    </div>

    <div class="primary content">
      <div class="ui tiny negative message" v-if="errorMessage">
        <i class="bullhorn icon"></i>
        {{ errorMessage }}
      </div>
      <!-- MQ SERVICE -->
      <div class="field">
        <typeahead
          :max-items="100"
          :current-item="service.name"
          :items="allMQServices"
          :label-text="$tc('MQ_SERVICE', 1)"
          :placeholder-text="$tc('MQ_SERVICE', 1)"
          :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('MQ_SERVICE', 2) })"
          :select-handler="setService"
          :remove-handler="clearService"
        >
          <template slot="dropdown" slot-scope="props">
            {{ $t(props.item.name) }}
          </template>
        </typeahead>
      </div>
      <!-- MESSAGE PATTERN -->
      <regex-field
        v-model="trigger.configuration.messagePattern"
        :labelText="$t('MQ_TRIGGER_MESSAGE_MATCH')"
      />
      <!-- CLAIM PATTERN -->
      <regex-field
        v-model="trigger.configuration.claimPattern"
        :labelText="$t('MQ_TRIGGER_CLAIM_MATCH')"
      />
      <!-- REPLY EXPECTED -->
      <div class="field">
        <div class="ui checkbox">
          <input type="checkbox" v-model="trigger.configuration.replyExpected" />
          <label>{{ $t('MQ_TRIGGER_REPLY_EXPECTED') }}</label>
        </div>
      </div>
    </div>

    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import _ from 'lodash'
import { Service } from 'services'
import { map } from 'rxjs/operators'
import { Typeahead, RegexField } from 'ui'

export default {
  name: 'MQServiceTrigger',
  components: { Typeahead, RegexField },

  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {
            serviceId: '',
            messagePattern: '',
            claimPattern: '',
            replyExpected: false
          }
        }
      }
    }
  },

  data() {
    return {
      service: {},
      errorMessage: null
    }
  },

  computed: {
    allServices() {
      return this.$store.state.service.items
    },
    allMQServices() {
      return _.map(_.filter(this.allServices, s => s.serviceType === 'MQ'), s => {
        return { name: s.name || s.id, key: s.id, id: s.id, value: s.id }
      })
    }
  },

  methods: {
    setService(s) {
      this.trigger.configuration.serviceId = s.id
    },
    clearService() {
      this.trigger.configuration.serviceId = ''
    }
  },

  created() {
    Service.readAllServices()
  },

  mounted() {
    if (_.isEmpty(this.service))
      this.service =
        _.find(this.allServices, s => s.id === this.trigger.configuration.serviceId) || {}
  },

  watch: {
    allServices() {
      if (_.isEmpty(this.service))
        this.service =
          _.find(this.allServices, s => s.id === this.trigger.configuration.serviceId) || {}
    }
  }
}
//
</script>
